$(".btn-see-cellphone").each(function ($item) {
    $(this).click(function () {
        //alert($(this).prop("id"));
        debugger;

        const botao = $(this);
        $.ajax({
            url: URL("condominio/serviceproviders/storeclickphone/" + $(this).prop("id")),
            type: 'post',
            beforeSend: function () {
                botao.fadeOut(100);
            },

            success: function (result) {
                botao.fadeIn(100);
                settextanimation(botao, result);
                botao.attr('onclick', '').unbind('click');
                botao.click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const iconwhats = $(this).find("div[class=icon-whatsapp]");

                    console.log(iconwhats);
                    if (iconwhats.length == 1) {
                        var anchor = document.createElement('a');
                        anchor.href = "https://wa.me/55" + $(this).text().replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", "");
                        anchor.target = "_blank";
                        anchor.click();
                    } else {
                        var anchor = document.createElement('a');
                        anchor.href = "tel:" + $(this).text();
                        anchor.target = "_blank";
                        anchor.click();
                    }



                })
            },
            error: function (err) {
                botao.fadeIn(200);
                console.log(err);
                $(".loading").hide();
            }
        });
    })
});
$(".btn-see-email").each(function ($item) {
    $(this).click(function () {
        //alert($(this).prop("id"));
        const botao = $(this);
        $.ajax({
            url: URL("condominio/serviceproviders/storeclickemail/" + $(this).prop("id")),
            type: 'post',
            beforeSend: function () {
                botao.fadeOut(100);
            },

            success: function (result) {
                botao.fadeIn(100);
                settextanimation(botao, result);
                botao.attr('onclick', '').unbind('click');
                botao.click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const anchor = document.createElement('a');
                    anchor.href = "mailto:" + $(this).text();
                    anchor.target = "_blank";
                    anchor.click();


                })
            },
            error: function (err) {
                botao.fadeIn(200);
                console.log(err);
                $(".loading").hide();
            }
        });
    })
});

function settextanimation(element, text) {
    const iconwhats = element.find("div[class=icon-whatsapp]");

    jQuery({ count: 0 }).animate({ count: text.length }, {
        duration: 1100,
        step: function () {
            element.text(text.substring(0, Math.round(this.count)));
        },
        done: function () {
            if (iconwhats.length == 1)
                element.append(iconwhats)
        }

    });
}
function URL(urlpath) {
    let url = "";
    url += window.location.protocol + "//";
    url += window.location.hostname;
    const porta = window.location.href
        .replace(window.location.protocol + "//", '')
        .replace(window.location.pathname, '')
        .replace(window.location.hostname, '')
        .replace(":", "");

    if (!isNaN(porta)) {
        url += ":" + porta;
    }
    if (urlpath.charAt(0) == '/') {
        return url + urlpath;
    } else {
        return url + "/" + urlpath;
    }
}
